<template>
  <i
    class="inline-block bg-contain bg-center bg-no-repeat leading-none"
    :style="{
      backgroundImage: `url('/sc/images/flags/${isoCode.toLowerCase()}.svg')`,
      width: 'calc((4 / 3) * 1em)',
    }"
    aria-hidden="true"
    >&#160;</i
  >
</template>

<script setup lang="ts">
defineProps<{
  isoCode: string;
}>();
</script>
